import axios from 'axios';

import { handleApiSucess, handleApiError, getRequestHeaders } from 'api/util.api';
import { handleRequest } from './util.api';

const getGroupsUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/customgroup`;

const toggleGroupUrl = (pId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/customgroup/${pId}/toggle`;

const getGroupByIdUrl = (pId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/customgroup/${pId}`;

const updateGroupUrl = (pId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/customgroup/${pId}`;

const addGroupUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/customgroup`;

const service = {
  configure(endpoint = '', auth = {}, defaultHeaders = {}) {
    this.endpoint = endpoint;
    this.auth = auth;
    this.defaultHeaders = defaultHeaders;
    this.getHeaders = getRequestHeaders(this.auth, this.defaultHeaders);

    this.axios = axios.create({
      baseURL: this.endpoint,
      timeout: 30000,
    });

    this.axios.interceptors.request.use((request) => {
      handleRequest(request);
      return request;
    });

    return this;
  },

  get(companyId, subcompanyId, filters, limit, page, orderBy, order) {
    const url = getGroupsUrl(companyId, subcompanyId);
    const params = { ...filters, limit, page, orderBy, order };
    return this.axios
      .get(url, { ...this.getHeaders(), params })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  toggle(groupId, companyId, subcompanyId) {
    const url = toggleGroupUrl(groupId, companyId, subcompanyId);
    return this.axios
      .put(url, {}, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  getById(groupId, companyId, subcompanyId) {
    const url = getGroupByIdUrl(groupId, companyId, subcompanyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  update(groupId, companyId, subcompanyId, provider) {
    const url = updateGroupUrl(groupId, companyId, subcompanyId);
    return this.axios
      .put(url, provider, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  add(companyId, subcompanyId, provider) {
    const url = addGroupUrl(companyId, subcompanyId);
    return this.axios
      .post(url, provider, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },
};

export default service;



// WEBPACK FOOTER //
// src/lib/api/groups.api.js